<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <div class="row mt-3 ml-2 mr-2">
            <div class="col-md-9 col-xs-9 col-sm-9 mb-2">
              <h4><b>ประวัติวอลล์แมน/วอลล์เลดี้ <i class="fab fa-black-tie"></i></b></h4>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="exportFromExcel()">
                ดาวน์โหลด XLSX <i class="far fa-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 col-sm-12">
          <vue-bootstrap4-table :rows="table.rows" :columns="table.columns" @refresh-data="sendAPIMinis"
          :config="table.config">
          <template slot="wm_status" slot-scope="props">
            <span v-if="props.cell_value==='active'" class="badge badge-pill badge-success">&nbsp;Active&nbsp;</span>
            <span v-else-if="props.cell_value==='quit'" class="badge badge-pill badge-danger">&nbsp;Quit&nbsp;</span>
            <span v-else-if="props.cell_value==='pending'" class="badge badge-pill badge-warning">&nbsp;Pending&nbsp;</span>
            <span v-else class="badge badge-pill badge-secondary">&nbsp;{{props.cell_value}}&nbsp;</span>
          </template>
          <template slot="view" slot-scope="props">
            <button @click="viewByID(props.cell_value)" type="button" class="btn btn-info"><i class="far fa-eye"></i></button>
          </template>
          <template slot="edit" slot-scope="props">
            <router-link :to="{ name: 'WallsmenEdit', params: { wm_id: props.cell_value }}" v-if="props.cell_value!=''&&props.cell_value!=null">
              <button class="btn btn-warning"><i class="far fa-user-edit"></i></button>
            </router-link>
            <span v-else>-</span>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
  </div>
  <b-modal :title="modal.title" ref="model" hide-footer v-model="modal.active" @ok="closeModal()">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div>
          <div v-html="modal.detail"></div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
              <button type="button" class="btn btn-primary form-control" @click="closeModal()"><i class="far fa-door-closed"></i> ปิด</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
  <Loading :percent="load.percent" :active="load.active"></Loading>
</div>
</template>
<script>
import XLSX from 'xlsx';
import JWT from '../../utils/JWT.js';
export default {
  components: {
    'VueBootstrap4Table': () => import('vue-bootstrap4-table'),
    'Loading': () => import('../../utils/Loading.vue')
  },
  data() {
    return {
      modal: {
        id:null,
        action:null,
        title: '',
        detail: '',
        active: false
      },
      alert: {
        message: ''
      },
      load: {
        task: 0,
        count: 0,
        percent: 0,
        active: false
      },
      table: {
        rows: [],
        config: {
          per_page: 15,
          per_page_options: [15, 25, 50, 75, 100],
          global_search: {
            placeholder: "ค้นหา...",
          }
        },
        columns: []
      }
    }
  },
  async mounted() {
    this.sendAPIMinis();
  },
  methods: {
    openModal(){
      this.modal.active=true
      this.$refs.model.show()
    },
    closeModal() {
      this.modal.id=null
      this.modal.action=null
      this.load.active = false
      this.$refs.model.hide()
    },
    resetLoading(task) {
      this.load.count = 0
      this.load.task = task
      this.load.percent = 0
      this.load.active = true
    },
    async viewByID(id){
      try {
        this.load.active = true
        this.modal.title='ข้อมูลของ WallsMan ID : '+id;
        this.modal.detail='';
        const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/wallsman/'+await JWT.encode({
          id: id
        }))).body
        if(res['id']){
          if(res['dt_code']){
            this.modal.detail=this.modal.detail+'<b>รหัสศูนย์กระจายสินค้า:</b> '+res['dt_code']+'<br>'
          }
          if(res['dt_name']){
            this.modal.detail=this.modal.detail+'<b>ศูนย์กระจายสินค้า:</b> '+res['dt_name']+'<br>'
          }
          if(res['mini_code']){
            this.modal.detail=this.modal.detail+'<b>รหัสมินิ:</b> '+res['mini_code']+'<br>'
          }
          if(res['mini_name']){
            this.modal.detail=this.modal.detail+'<b>ชื่อมินิ:</b> '+res['mini_name']+'<br>'
          }
          if(res['wm_code']){
            this.modal.detail=this.modal.detail+'<b>รหัสวอลล์แมน/วอลล์เลดี้:</b> '+res['wm_code']+'<br>'
          }
          if(res['title']){
            this.modal.detail=this.modal.detail+'<b>คำนำหน้า:</b> '+res['title']+'<br>'
          }
          if(res['full_name']){
            this.modal.detail=this.modal.detail+'<b>ชื่อ - นามสกุล:</b> '+res['full_name']+'<br>'
          }
          if(res['bike_barcode']){
            this.modal.detail=this.modal.detail+'<b>บาร์โค้ดรถมอเตอร์ไซค์:</b> '+res['bike_barcode']+'<br>'
          }
          if(res['plate_no']){
            this.modal.detail=this.modal.detail+'<b>ทะเบียนรถมอเตอร์ไซค์:</b> '+res['plate_no']+'<br>'
          }
          if(res['passport_number']){
            this.modal.detail=this.modal.detail+'<b>พาสปอร์ต:</b> '+res['passport_number']+'<br>'
          }
          if(res['citizen_id']){
            this.modal.detail=this.modal.detail+'<b>เลขที่บัตรประจำตัวประชาชน:</b> '+res['citizen_id']+'<br>'
          }
          if(res['address_number']||res['moo']||res['soi']||res['sub_district']||res['district']||res['province']||res['post_code']){
            this.modal.detail=this.modal.detail+'<b>ที่อยู่:</b> '
            if(res['address_number']){
              this.modal.detail=this.modal.detail+res['address_number']
            }
            if(res['moo']){
              this.modal.detail=this.modal.detail+' หมู่ '+res['moo']

            }
            if(res['soi']){
              this.modal.detail=this.modal.detail+' ซอย '+res['soi']
            }
            if(res['sub_district']){
              this.modal.detail=this.modal.detail+' เขต '+res['sub_district']
            }
            if(res['district']){
              this.modal.detail=this.modal.detail+' แขวง '+res['district']
            }
            if(res['province']){
              this.modal.detail=this.modal.detail+' จังหวัด '+res['province']
            }
            if(res['post_code']){
              this.modal.detail=this.modal.detail+' รหัสไปรษณีย์ '+res['post_code']
            }
            this.modal.detail=this.modal.detail+'<br>'
          }
          if(res['contact_address']){
            this.modal.detail=this.modal.detail+'<b>เบอร์โทรศัพท์ที่อยู่:</b> '+res['contact_address']+'<br>'
          }
          if(res['contact_number']){
            this.modal.detail=this.modal.detail+'<b>เบอร์โทรศัพท์:</b> '+res['contact_number']+'<br>'
          }
          if(res['date_of_birth']){
            this.modal.detail=this.modal.detail+'<b>วันเกิด(ปี ค.ศ.):</b> '+res['date_of_birth']+'<br>'
          }
          if(res['shirt_size']){
            this.modal.detail=this.modal.detail+'<b>ขนาดเสื้อ:</b> '+res['shirt_size']+'<br>'
          }
          if(res['trousers_size']){
            this.modal.detail=this.modal.detail+'<b>ขนาดกางเกง:</b> '+res['trousers_size']+'<br>'
          }
          if(res['first_date']){
            this.modal.detail=this.modal.detail+'<b>เข้าเมื่อวันที่:</b> '+res['first_date']+'<br>'
          }
          if(res['wm_code']&&res['wm_code']!=''&&res['wm_status']){
            this.modal.detail=this.modal.detail+'<b>สถานะ:</b> '
            switch (res['wm_status'].toLowerCase()) {
              case 'active':
              this.modal.detail=this.modal.detail+ '<span class="badge badge-pill badge-success">&nbsp;กำลังทำงาน&nbsp;</span><br>';
              break;
              case 'inactive':
              this.modal.detail=this.modal.detail+ '<span class="badge badge-pill badge-danger">&nbsp;ออกแล้ว&nbsp;</span><br>';
              break;
              case 'quit':
              this.modal.detail=this.modal.detail+ '<span class="badge badge-pill badge-danger">&nbsp;ออกแล้ว&nbsp;</span><br>';
              break;
              case 'blacklist':
              this.modal.detail=this.modal.detail+ '<span class="badge badge-pill badge-secondary">&nbsp;blacklist&nbsp;</span><br>';
              break;
              default: 
              this.modal.detail=this.modal.detail+ '<span class="badge badge-pill badge-warning">&nbsp;รอกการตรวจสอบ&nbsp;</span><br>';
            }
            this.modal.detail=this.modal.detail+'<b>เข้าเมื่อวันที่:</b> '+res['first_date']+'<br>'
          }else{
            this.modal.detail=this.modal.detail+'<b>สถานะ:</b> <span class="badge badge-pill badge-warning">&nbsp;รอกการตรวจสอบ&nbsp;</span><br>'
          }
          if(res['created_at']){
            this.modal.detail=this.modal.detail+'<b>สร้างเมื่อวันที่:</b> '+res['created_at']
          }
          if(res['beneficiary_full_name']||res['beneficiary_contact_number']||res['beneficiary_citizen_id']||res['beneficiary_relationship']||res['beneficiary_title']){
            this.modal.detail=this.modal.detail+'<hr><b class="text-center">ผู้รับผลประโยชน์กรณีเกิดอุบัติเหตุ</b><br>'
            if(res['beneficiary_citizen_id']){
              this.modal.detail=this.modal.detail+'<b>เลขที่บัตรประจำตัวประชาชน:</b> '+res['beneficiary_citizen_id']+'<br>'
            }
            if(res['beneficiary_title']){
              this.modal.detail=this.modal.detail+'<b>คำนำหน้า:</b> '+res['beneficiary_title']+'<br>'
            }
            if(res['beneficiary_full_name']){
              this.modal.detail=this.modal.detail+'<b>ชื่อ - นามสกุล:</b> '+res['beneficiary_full_name']+'<br>'
            }
            if(res['beneficiary_relationship']){
              this.modal.detail=this.modal.detail+'<b>ความสัมพันธ์:</b> '+res['beneficiary_relationship']+'<br>'
            }
            if(res['beneficiary_contact_number']){
              this.modal.detail=this.modal.detail+'<b>เบอร์โทรศัพท์:</b> '+res['beneficiary_relationship']+'<br>'
            }
          }
          if(res['updated_at']){
            this.modal.detail=this.modal.detail+'<hr><b>ข้อมูลทั้งหมดอัพเดทเมื่อวันที่:</b> '+res['updated_at']
          }
          this.load.active = false
          this.modal.active=true;
          this.$refs.model.show()
        }else{
          this.closeModal();
        }
      } catch (error) {
        this.closeModal();
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการส่งข้อมูล'})
      }
    },
    async sendAPIMinis() {
      try {
        await this.resetLoading(1)
        this.table.rows = []
        const res = ((await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/user/wallsman')).body)
        let value = null, data = [], wmStatus='', idAction='', dataSet={}
        this.table.columns=[{
          label: "ID",
          name: "id",
          sort: true
        }, {
          label: "รหัสศูนย์กระจายสินค้า",
          name: "dt_code",
          sort: true
        }, {
          label: "รหัสมินิ",
          name: "mini_code",
          sort: true
        }, {
          label: "ชื่อมินิ",
          name: "mini_name",
          sort: true
        }, {
          label: "รหัสวอลล์แมน/วอลล์เลดี้",
          name: "wm_code",
          sort: true
        }, {
          label: "ชื่อ - นามสกุล",
          name: "full_name",
          sort: true
        }, {
          label: "เลขที่บัตรประจำตัวประชาชน",
          name: "citizen_id",
          sort: true
        }, {
          label: "สถานะ",
          name: "wm_status",
          sort: true
        }, {
          label: "บาร์โค้ดรถมอเตอร์ไซค์",
          name: "bike_barcode",
          sort: true
        }, {
          label: "วันที่อัพเดท",
          name: "updated_at",
          sort: true,
          initial_sort: true,
          initial_sort_order: "desc"
        },{
          label: "View",
          name: "view",
          sort: true,
        }]
        if(res['type']==='miniuser'){
          this.table.columns.push({
            label: "Edit",
            name: "edit",
            sort: true,
          });
        }
        for(value of res['data']){
          if(value.wm_code&&value.wm_code!=''){
            wmStatus=value.wm_status.toLowerCase()
            idAction=value.id
          }else{
            wmStatus = 'pending'
            idAction=''
          }
          if(wmStatus==='quit'){
            idAction=''
          }
          dataSet={
            id: value.id,
            dt_code: value.dt_code,
            mini_code: value.mini_code,
            mini_name: value.mini_name,
            wm_code: value.wm_code,
            full_name: value.full_name,
            citizen_id: value.citizen_id,
            wm_status: wmStatus,
            bike_barcode: value.bike_barcode,
            updated_at: value.updated_at,
            view: value.id
          };
          if(res['type']==='miniuser'){
            dataSet['edit']=idAction
          }
          data.push(dataSet)
        }
        this.table.rows = data
        this.load.active = false
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
      }
    },
    errorModal(error,miniCode){
      this.load.active = false
      if (error.body) {
        if (error.body.alert) {
          this.alert.message = error.body.alert
        } else {
          this.alert.message = 'ไม่สามารถดึงข้อมูลของมินิ "'+miniCode+'" กับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
      } else {
        this.alert.message = 'ไม่สามารถดึงข้อมูลของมินิ "'+miniCode+'" กับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
      }
      this.$dialogs.alert(this.alert.message,{title: 'เกิดข้อผิดพลาดในการดึงข้อมูล'})
    },
    async exportFromExcel() {
      let data = [],
      value = null;
      for (value of this.table.rows) {
        data.push({
          id: value.id,
          mini_code: value.mini_code,
          mini_name: value.mini_name,
          wm_code: value.wm_code,
          full_name: value.full_name,
          citizen_id: value.citizen_id,
          wm_status: value.wm_status,
          bike_barcode: value.bike_barcode,
          updated_at: value.updated_at
        })
      }
      if (data.length > 0) {
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(data), 'WMs')
        XLSX.writeFile(wb, 'wms_' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + '.xlsx')
        this.$notify({
          title: 'Export Excel',
          text: 'Export Excel Succeed!'
        });
      }
    }
  }
}

</script>
